module.exports = __webpack_public_path__ + "static/media/baby_macaque.44e8fe40.jpg";